import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'CCUsers',
})

export class CCUsersPipe implements PipeTransform {
	public transform(user: any): any {
		if (user.firstName && user.lastName) {
			return user.firstName + ' ' + user.lastName + ' - ' + user.email;
		} else {
			return user.name + ' - ' + user.email;
		}
	}
}